export const GET_BANNERBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    bannerBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      text
      colorCombination
      linkReference {
        globalLinkItem
        url
        linkText
        variant
        reference {
          ... on Page {
            content {
              __typename
            }
            slug
          }
          ... on FileBlock {
            imageVaultFile
            __typename
          }
        }
      }
    }
  }
`;
